import { render } from "./menu-item.vue?vue&type=template&id=4e60e1db"
import script from "./menu-item.vue?vue&type=script&lang=js"
export * from "./menu-item.vue?vue&type=script&lang=js"

import "./menu-item.vue?vue&type=style&index=0&id=4e60e1db&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__